// extracted by mini-css-extract-plugin
export default {"activity":"YxcAxX","fixedTextSize":"UaQL01","fixedActivityTextSize":"oTtaXY","mobileTextSize":"UOM72h"};